import React, { useState, useEffect, useRef } from "react"
import Select from "react-select"
// import CreatableSelect from "react-select/creatable"
import { Row, Col, Input, Label, Button, Table, Spinner } from "reactstrap"
import { withRouter, useParams } from "react-router-dom"
import PropTypes from "prop-types"
import Modal from "react-bootstrap/Modal"
import { connect, useSelector, useDispatch } from "react-redux"
import { get, isEmpty } from "lodash"
import { toast } from "react-toastify"
import * as eventAction from "../../store/zXZlbnQq/actions"
import * as quotationAction from "../../store/cXVvdGF0/actions"
import { CCarousel, CCarouselItem, CImage } from "@coreui/react"
import SimpleReactValidator from "simple-react-validator"
// import { styles } from "./Input-Select/select"
// import { ReactSearchAutocomplete } from "react-search-autocomplete"
import moment from "moment"
import api from "../../helpers/Api"

const EcEventDetails = (props) => {
  const { dispatch, clientProfile, location,multiArrayLeadId,ecLoading } = props
  const [isEdit, setIsEdit] = useState(false)
  const [eventModal, setEventModal] = useState(false)

  const [managerView, setManagerView] = useState(false)
  const [venueLocations, setVenueLocations] = useState([])
  const [eventLoading, setEventLoading] = useState("")
  const [newVenue, setNewVenue] = useState("")
  const [venueAdd, setVenueAdd] = useState(false)
  const [newVenueLocation, setNewVenueLocation] = useState("")
  const [venueLocationAdd, setVenueLocationAdd] = useState(false)
  const [addedVenueLocation, setAddedVenueLocation] = useState(false)

  const processStatus =
    clientProfile && clientProfile.leadDetails
      ? clientProfile.leadDetails[0].processStatus
      : []

  console.log(processStatus, "processStatus")
  console.log(location, "location")
  console.log(ecLoading, "ecLoading")

  let { id } = useParams()
  useEffect(() => {
    if (ecLoading === true) {
    // dispatch(eventAction.loadRecordsMetaData())
    dispatch(eventAction.loadVenueList(multiArrayLeadId))
    dispatch(eventAction.loadCityVenueList(multiArrayLeadId))
    dispatch(eventAction.loadRecordEventDetails(multiArrayLeadId))
    dispatch(quotationAction.loadQuotationList(multiArrayLeadId))
    dispatch(eventAction.loadVenueLocations(multiArrayLeadId))
    } else {
      // dispatch(eventAction.loadRecordsMetaData())
    dispatch(eventAction.loadVenueList(id))
    dispatch(eventAction.loadCityVenueList(id))
    dispatch(eventAction.loadRecordEventDetails(id))
    dispatch(quotationAction.loadQuotationList(id))
    dispatch(eventAction.loadVenueLocations(id))
    }
  }, [ecLoading])

  const specificDispatch = useDispatch()

  const eventBranchId =
    clientProfile &&
    clientProfile.leadDetails &&
    clientProfile.leadDetails[0].branchId
  const eventCompanyId =
    clientProfile &&
    clientProfile.leadDetails &&
    clientProfile.leadDetails[0].companyId

  const [eventData, setEventData] = useState({
    status: 1,
    leadId: id,
    isLink: true,
    branchId: eventBranchId,
    eventType: [],
    event: [],
    eventDate: "",
    crewAssemblyTime: "",
    startTime: "",
    endTime: "",
    venueLocation: [],
    venueName: [],
    venueId: "",
    cityId: "",
    crowdStrength: "",
    notes: "",
    cityName: [],
  })

  const {
    // eventType,
    // event,
    eventDate,
    crewAssemblyTime,
    startTime,
    endTime,
    // venueLocation,
    // venueName,
    crowdStrength,
    notes,
    // branch,
  } = eventData
  // const data = eventDate

  const [eventDateList, setEventDateList] = useState("")

  const getEventDate = async (eventDate) => {
    let payload = { eventDate: eventDate }
    const eventDateResponse = await api
      .post(`/get_all_lead_event_date`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
    setEventDateList(eventDateResponse)
  }

  const muhurthamList = !isEmpty(eventDateList) && eventDateList.data
  const priorityStatus =
    muhurthamList && muhurthamList.muhurthamData
      ? muhurthamList.muhurthamData.map(
          (muhurtham) => muhurtham.priorityStatusName
        )
      : []
  const [offerDateList, setOfferDateList] = useState([])

  console.log(priorityStatus, "priorityStatus")

  const getOfferDate = async (eventDate) => {
    let payload = { eventDate: eventDate }
    const offerDateResponse = await api
      .post(`/get_all_lead_offer_date`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
    setOfferDateList(offerDateResponse)
  }

  const offerListDetails = !isEmpty(offerDateList) && offerDateList.data

  const handleChange = (e) => {
    const data = moment(e.target.value).format("DD-MM-YYYY")
    if (e.target.name === "eventDate") {
      getEventDate(data)
      getOfferDate(data)
      setEventLoading(true)
      setTimeout(() => {
        setEventLoading(false)
      }, 2000)
    }

    setEventData({
      ...eventData,
      [e.target.name]: e.target.value,
    })
  }

  ///Event Store and data table
  const eventUpdate = useSelector((specificState) => specificState.Event)
  const sessionUpdate = useSelector((specificState) => specificState.session)
  const quotationUpdate = useSelector(
    (specificState) => specificState.quotation
  )

  const {
    record_event_details = [],
    city_venue = [],
    venue_locations = [],
    recordsMetaData = {},
  } = eventUpdate
  const { user = [] } = sessionUpdate
  const { quotationList = [] } = quotationUpdate

  const isQuotation = !isEmpty(quotationList) && quotationList[0].isQuotation
  const salesManagerId = !isEmpty(user) && user.roleId

  useEffect(() => {
    if (salesManagerId === "6320da65812dfec5383565f4" || isQuotation === true) {
      setManagerView(true)
    } else {
      setManagerView(false)
    }
  }, [salesManagerId, quotationList])

  console.log(managerView, "manager view")

  const eventBranch =
    !isEmpty(recordsMetaData.branchOptions) &&
    recordsMetaData.branchOptions.filter(
      (branch) => branch.companyId === eventCompanyId
    )

  //Venue Location options and funtionality

  const venueLocationsList =
    !isEmpty(venue_locations) &&
    venue_locations.map((venue) => {
      const venueLocation = venue.name.toUpperCase()
      if (venue.status === 1) {
        return {
          _id: venue._id,
          name: venueLocation,
        }
      } else {
        return {
          _id: "",
        }
      }
    })

  const createVenueLocationOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        let obj = {}
        obj.value = element._id
        obj.label = element.name
        options.push(obj)
      })
    return options
  }

  const venueLocationOptions = createVenueLocationOptions(venueLocationsList)

  const [venueLocationAdded, setVenueLocationAdded] = useState(false)

  var lastArrayCityId = venueLocationAdded
    ? venue_locations[venue_locations.length - 1]._id
    : []
  console.log(lastArrayCityId, "venue_locations")
  useEffect(() => {
    if (venueLocationAdded === true) {
      setVenueLocations({ label: newVenueLocation, value: lastArrayCityId })
      setEventData({
        ...eventData,
        venueLocation: [{ label: newVenueLocation, value: lastArrayCityId }],
      })
    }
  }, [venue_locations])

  //Venue name options and funtionality
  const venueList =
    !isEmpty(city_venue) &&
    city_venue.map((venue) => {
      const venueName = venue.venueName.toUpperCase()
      if (venue.status === 1) {
        return {
          cityId: venue.cityId,
          venueName: venueName,
          _id: venue._id,
          status: venue.status,
          isPremium: venue.isPremium,
        }
      } else {
        return {
          _id: "",
        }
      }
    })

  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        let obj = {}
        obj.value = element._id
        obj.label = element.venueName
        obj.cityId = element.cityId
        obj.isPremium = element.isPremium
        options.push(obj)
      })
    return options
  }

  const venueOptions = createOptions(venueList)

  const cityVenueOptions =
    !isEmpty(venueOptions) &&
    venueOptions.filter((city) => {
      return city.cityId === venueLocations.value
    })

  const [venueNameAdded, setVenueNameAdded] = useState(false)

  useEffect(() => {
    if (venueNameAdded === true) {
      setCityVenueName({ label: newVenue, value: "" })
      setEventData({
        ...eventData,
        venueName: [{ label: newVenue, value: "" }],
      })
    }
  }, [city_venue])

  //Change venue Location
  const handleVenueLocations = (e) => {
    setVenueLocations(e)
    setCityVenueName([])
    setPremium(false)
  }

  const handleVenueTab = () => {
    setVenueLocationAdd(!venueLocationAdd)
    setCityVenueName([])
    setVenueLocations([])
  }

  const handleVenueNameTab = () => {
    setVenueAdd(!venueAdd)
    setCityVenueName([])
  }

  const [eventTypes, setEventTypes] = useState([])
  const [premium, setPremium] = useState(false)
  const [events, setEvents] = useState([])
  const [cityVenueName, setCityVenueName] = useState([])
  const [city, setCity] = useState("")
  // const [cityVenue, setCityVenue] = useState("")
  const [offerCheck, setOfferCheck] = useState(false)
  // const [updateVenue, setUpdateVenue] = useState(false)
  //fuse options in venue name
  // const fuseOptions = {
  //   keys: ["label", "cityId"],
  // }

 

  //Validator
  const simpleValidator = useRef(new SimpleReactValidator())
  const [forceUpdate, setForceUpdate] = useState(false)
  //Form submission

  const handleSubmit = (e) => {
    e.preventDefault()
    if (simpleValidator.current.allValid()) {
      const eventUpdate = {
        status: 1,
        leadId: eventData.leadId,
        isLink: true,
        branchId: eventBranchId,
        eventType: eventTypes.value,
        event: events.value,
        eventDate: eventData.eventDate,
        crewAssemblyTime: eventData.crewAssemblyTime,
        startTime: eventData.startTime,
        endTime: eventData.endTime,
        venueLocation: venueLocations.label,
        venueName: cityVenueName.label,
        venueId: cityVenueName.value,
        cityId: city.value,
        crowdStrength: eventData.crowdStrength,
        notes: eventData.notes,
        cityName: city.label,
      }
      dispatch(eventAction.createEventRecord(eventUpdate))
      setTimeout(() => {
        dispatch(eventAction.loadRecordEventDetails(id))
        toast.success("Event Details Created Successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
        // setPageload(true)
      }, 2000)
      setEventModal(false)
    } else {
      simpleValidator.current.showMessages()
      setForceUpdate(true)
      setEventModal(true)
      console.log(forceUpdate)
      return false
    }
  }

  const eventTableDetails = get(record_event_details[0], "events", "")

  //Event Data Table section
  var slNo = 0
  const eventDataTable = !isEmpty(eventTableDetails)
    ? eventTableDetails.map((events, index) => {
        const eventId = get(events, "_id", "")
        const eventStatus = get(events, "status", "")
        const eventName = get(events, "eventName", "No Event")
        const event = get(events, "event", "No Event")
        const eventTypeName = get(events, "eventTypeName", "No Event")
        const eventType = get(events, "eventType", "No Event")
        const eventNo = get(events, "eventNo", "No Event")
        const eventDate = get(events, "eventDate", "No EventDate")
        const eventCrewAssemblyTime = get(events, "crewAssemblyTime", "No Ev")
        const eventStartTime = get(events, "startTime", "No Ev")
        const eventCityId = get(events, "cityId", "No Ev")
        const eventCityName = get(events, "cityName", "No Ev")
        const eventEndTime = get(events, "endTime", "No Ev")
        const eventLocation = get(events, "venueLocation", "No Event Location")
        const eventVenueName = get(events, "venueName", "No Event Name")
        const eventVenueId = get(events, "venueId", "No Event Name")
        const eventCrowdStrength = get(
          events,
          "crowdStrength",
          "No CrowdStrength"
        )

        if (eventStatus === 1) {
          slNo = slNo + 1
          return {
            _id: eventId,
            sNo: slNo,
            status: eventStatus,
            eventType: eventTypeName,
            event: eventName,
            eventNo: eventNo,
            eventTypeId: eventType,
            eventId: event,
            eventDate: moment(eventDate).format("DD-MM-YYYY"),
            notes: events.notes,
            crewAssemblyTime: eventCrewAssemblyTime,
            startTime: eventStartTime,
            endTime: eventEndTime,
            venueLocation: eventLocation,
            venueName: eventVenueName,
            venueId: eventVenueId,
            crowdStrength: eventCrowdStrength,
            cityId: eventCityId,
            cityName: eventCityName,
            key: index,
          }
        } else {
          return { _id: "" }
        }
      })
    : []

  // const [venueId, setVenueId] = useState("")
  const [addedVenue, setAddedVenue] = useState(false)

  useEffect(() => {
    eventData
  }, [eventData])

  //Update
  const handleUpdate = (e, success) => {
    e.preventDefault()
    if (simpleValidator.current.allValid()) {
      const eventUpdate = {
        status: 1,
        leadId: eventData.leadId,
        leadEventDetailId: eventData.leadEventDetailsId,
        isLink: true,
        branchId: eventData.branchId,
        eventType: eventTypes.value,
        event: events.value,
        eventDate: eventData.eventDate,
        crewAssemblyTime: eventData.crewAssemblyTime,
        startTime: eventData.startTime,
        endTime: eventData.endTime,
        venueLocation: venueLocations.label,
        venueName: cityVenueName.label,
        venueId: cityVenueName.value,
        crowdStrength: eventData.crowdStrength,
        notes: eventData.notes,
        cityName: city.label,
        cityId: venueLocations.value,
      }
      specificDispatch(eventAction.updateEventRecord(eventUpdate, success))

      setTimeout(() => {
        specificDispatch(eventAction.loadRecordEventDetails(id))
        toast.success("Event Details Updated Successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
        // setPageload(true)
      }, 2000)
      setIsEdit(false)
    } else {
      simpleValidator.current.showMessages()
      setForceUpdate(true)
      setEventModal(true)
      console.log(forceUpdate)
      return false
    }
  }

  const venueNameNew = addedVenueLocation
    ? venueLocationOptions.filter((venue) => venue.label === newVenueLocation)
    : []

  console.log(venueNameNew, "venueNameNew")

  //Add venue details
  const addVenueDetails = () => {
    const venueData = {
      venueName: newVenue.toUpperCase(),
      isPremium: premium,
      cityId: venueLocations.value,
    }
    specificDispatch(eventAction.addVenueList(venueData))
    setVenueAdd(false)
    setAddedVenue(true)
    setTimeout(() => {
      specificDispatch(eventAction.loadCityVenueList(id))
      setAddedVenue(false)
    }, 2000)
  }
  //Update venue details
  // const updateVenueDetails = () => {
  //   const venueData = {
  //     _id: venueId,
  //     cityId: venueLocations.value,
  //     venueName: newVenue,
  //     isPremium: premium,
  //   }
  //   specificDispatch(eventAction.updateVenueList(venueData))
  //   setTimeout(() => {
  //     specificDispatch(eventAction.loadCityVenueList(id))
  //   }, 2000)
  // }
  //Add venue Location details
  const addVenueLocationDetails = () => {
    const locationData = {
      name: newVenueLocation.toUpperCase(),
    }
    specificDispatch(eventAction.addVenueLocations(locationData))
    setVenueLocationAdd(false)
    setAddedVenueLocation(true)
    // toast.success("New venue added successfully")
    setTimeout(() => {
      specificDispatch(eventAction.loadVenueLocations(id))
      setAddedVenueLocation(false)
    }, 2000)
  }
  //Update venue details
  // const updateVenueLocationDetails = () => {
  //   const locationData = {
  //     _id: id,
  //     name: newVenueLocation,
  //   }
  //   specificDispatch(eventAction.updateVenueLocations(locationData))
  //   setTimeout(() => {
  //     specificDispatch(eventAction.loadVenueLocations(id))
  //   }, 2000)
  // }

  //Delete Event
  // const [eventRemoveId, setEventRemoveId] = useState("")

  // const removeEventDetails = (success) => {
  //   specificDispatch(eventAction.deleteEventRecord(eventRemoveId, success))
  //   setTimeout(() => {
  //     specificDispatch(eventAction.loadRecordEventDetails(id))
  //     // setPageload(true)
  //     toast.success("Event details deleted successfully", {
  //       position: toast.POSITION.TOP_RIGHT,
  //       autoClose: 1000,
  //     })
  //   }, 2000)
  // }

  const [offerList, setOfferList] = useState(false)
  // const [deleteForm, setDeleteForm] = useState(false)
  // const handleClose = () => setDeleteForm(false)
  const [branchShow, setBranchShow] = useState(false)

  const offerSubmit = (offerList) => {
    specificDispatch(eventAction.createOfferRecord(offerList))
  }

  return (
    <React.Fragment>
      <Row>
        {/* Event Details Section */}
        <Col
          style={{
            display: "flex",
            alignItems: "center",
            paddingTop: "20px",
            paddingBottom: "15px",
          }}
        >
          <p
            style={{
              color: "#4486eb",
              margin: "0px",
              marginRight: "15px",
              fontSize: "16px",
              fontWeight: "500",
            }}
          >
            Event Details
          </p>
          {/* {managerView ? (
            ""
          ) : ( */}
         

          {/* // )} */}
        </Col>
        <Table striped bordered responsive className="mb-2">
          <thead>
            <tr style={{ fontSize: "10px" }}>
              <th>S.No</th>
              {/* <th>Actions</th> */}
              <th style={{ minWidth: "120px" }}>Event Name</th>
              <th style={{ minWidth: "120px" }}>Event Type</th>
              <th style={{ minWidth: "105px" }}>Event No</th>
              <th style={{ minWidth: "105px" }}>Event Date</th>
              <th style={{ minWidth: "125px" }}>Assembly Time</th>
              <th style={{ minWidth: "105px" }}>Start Time</th>
              <th style={{ minWidth: "105px" }}>End Time</th>
              <th style={{ minWidth: "105px" }}>Location</th>
              <th style={{ minWidth: "110px" }}>Venue</th>
              <th style={{ minWidth: "130px" }}>Crowd Strength</th>
            </tr>
          </thead>
          <tbody>
            {eventDataTable.map((events) => {
              if (events.status === 1) {
                return (
                  <tr key={events.id} style={{ textTransform: "uppercase" }}>
                    <td>{events.sNo}</td>
                    {/* <td
                      className="d-flex flex-row"
                      style={{ paddingBottom: "40px" }}
                    >
                      <Button
                        type="submit"
                        style={{ fontSize: "8px" }}
                        onClick={() => {
                          editEventDetails(events)
                        }}
                        className={
                          processStatus === "PS6" ||
                          processStatus === "PS8" ||
                          processStatus === "PS9" ||
                          processStatus === "PS17" ||
                          processStatus === "PS19"
                            ? "btn btn-success disabled-button"
                            : "btn btn-success"
                        }
                      >
                        <i className="fas fa-edit icon-btn"></i>
                      </Button>
                      <Button
                        type="submit"
                        style={{ fontSize: "8px" }}
                        onClick={() => {
                          setDeleteForm(true)
                          setEventRemoveId(events._id)
                        }}
                        className={
                          processStatus === "PS6" ||
                          processStatus === "PS8" ||
                          processStatus === "PS9" ||
                          processStatus === "PS17" ||
                          processStatus === "PS19"
                            ? "mx-1 btn btn-danger disabled-button"
                            : "mx-1 btn btn-danger"
                        }
                      >
                        <i className="bx bx-block icon-btn"></i>
                      </Button>
                    </td> */}
                    <td>{events.event}</td>
                    <td>{events.eventType}</td>
                    <td>{events.eventNo}</td>
                    <td>{events.eventDate}</td>
                    <td>{events.crewAssemblyTime}</td>
                    <td>{events.startTime}</td>
                    <td>{events.endTime}</td>
                    <td>{events.venueLocation}</td>
                    <td>{events.venueName}</td>
                    <td>{events.crowdStrength}</td>
                  </tr>
                )
              }
            })}
          </tbody>
        </Table>
        <Col className="mt-2 event-detail-content">
          {eventModal && (
            <form>
              <Row className="event-card-content">
                {/* Offer section */}
                <Col md="12" lg="4" xl="4" sm="12" xs="12">
                  <div style={{ marginTop: "10px" }}>
                    <div
                      className={
                        muhurthamList.isMuhurtham === "yes"
                          ? "bg-white muhurtham-btn"
                          : "bg-white non-muhurtham-btn"
                      }
                    >
                      <span>
                        {muhurthamList.isMuhurtham === "yes"
                          ? "Muhurtham" + " - " + priorityStatus
                          : "Non Muhurtham"}
                      </span>
                    </div>
                  </div>
                  <table className="offer-table-main">
                    <tr className="offer-table-row">
                      <td className="offer-table-data">No of Enquiries</td>
                      <td className="offer-table-detail">
                        {muhurthamList.totalLead ? muhurthamList.totalLead : 0}
                      </td>
                    </tr>
                    <tr className="offer-table-row">
                      <td className="offer-table-data">No of Booked Events</td>
                      <td className="offer-table-detail">{0}</td>
                    </tr>
                    <tr className="offer-table-row">
                      <td className="offer-table-data">No of Rejects</td>
                      <td className="offer-table-detail">{0}</td>
                    </tr>
                    <tr className="offer-table-row">
                      <td className="offer-table-data">No of Followup</td>
                      <td className="offer-table-detail">
                        {muhurthamList.totalLeadCurrentFollowup
                          ? muhurthamList.totalLeadCurrentFollowup
                          : 0}
                      </td>
                    </tr>
                  </table>
                  <div className="offer-button">
                    {offerListDetails.length < 1 ? (
                      ""
                    ) : (
                      <>
                        <Button
                          onClick={() => setOfferList(true)}
                          style={{
                            color: "white",
                            background: "red",
                            border: "none",
                          }}
                          className="offer-form-btn"
                        >
                          Offers
                        </Button>
                      </>
                    )}
                  </div>
                  {offerList && (
                    <Modal
                      style={{ margin: "10%" }}
                      show={offerList}
                      onHide={() => setOfferList(false)}
                    >
                      <Modal.Header>Offer Details</Modal.Header>
                      {!isEmpty(offerListDetails) &&
                      offerListDetails.length > 0 ? (
                        offerListDetails.map((offers) => {
                          return (
                            <div
                              key={offers.id}
                              onClick={() => setOfferCheck(true)}
                              className={offerCheck ? "" : "offer-check"}
                            >
                              {/* <Modal.Header>{offers.label}</Modal.Header> */}
                              <Modal.Body style={{ background: "aquamarine" }}>
                                <CCarousel>
                                  <CCarouselItem>
                                    <h2 style={{ textTransform: "uppercase" }}>
                                      {offers.offerTitle}
                                    </h2>
                                    <CImage
                                      src={offers.offerImage}
                                      className="d-block d-flex flex-row w-100"
                                      alt="image"
                                    ></CImage>
                                    <div className="d-flex flex-row mt-2">
                                      <p style={{ marginRight: "5px" }}>
                                        {moment(offers.fromDate).format(
                                          "YYYY-MM-DD"
                                        )}
                                      </p>{" "}
                                      {" - "}
                                      <p className="mx-2">
                                        {moment(offers.toDate).format(
                                          "YYYY-MM-DD"
                                        )}
                                      </p>
                                    </div>
                                  </CCarouselItem>
                                </CCarousel>
                              </Modal.Body>
                            </div>
                          )
                        })
                      ) : (
                        <p style={{ textAlign: "center" }}>{"No Data Found"}</p>
                      )}
                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          onClick={() => setOfferList(false)}
                        >
                          Close
                        </Button>
                        <Button
                          variant="primary"
                          className="btn btn-success"
                          onClick={(e) => {
                            offerSubmit(e)
                            setOfferList(false)
                          }}
                        >
                          Submit
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                </Col>
                <Col className="mt-2 mb-2 event-details-form-content">
                  <Row className="">
                    <Col lg="6" md="6" sm="12" xs="12" className="mt-3">
                      <Label className="event-label">
                        Event Type
                        <span className="event-required">*</span>
                      </Label>
                      <Select
                        name="eventType"
                        value={eventTypes}
                        options={
                          recordsMetaData
                            ? recordsMetaData.eventTypeOptions
                            : []
                        }
                        onChange={(e) => setEventTypes(e)}
                      />
                      {simpleValidator.current.message(
                        "eventType",
                        eventTypes,
                        "required"
                      )}
                    </Col>
                    <Col lg="6" md="6" sm="12" xs="12" className="mt-3">
                      <Label for="eventList" className="event-label">
                        Event List
                        <span className="event-required">*</span>
                      </Label>
                      <Select
                        name="event"
                        value={events}
                        // options={eventOptions}
                        options={
                          recordsMetaData ? recordsMetaData.eventOptions : []
                        }
                        onChange={(e) => setEvents(e)}
                        id="eventList"
                      />
                      {simpleValidator.current.message(
                        "event",
                        events,
                        "required"
                      )}
                    </Col>
                    <Col lg="6" md="6" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="event-label">
                          Date
                          {/* <span className="event-required">*</span> */}
                        </Label>
                        <div className="event-given-checkbox">
                          <Input
                            type="checkbox"
                            className="mt-1 event-given-input"
                          />
                          <label className="event-given-input-text">
                            Not Given
                          </label>
                        </div>
                      </div>
                      <Input
                        type="date"
                        name="eventDate"
                        value={eventDate}
                        onChange={(e) => {
                          handleChange(e)
                          // setDateSelected(true)
                        }}
                        placeholder="Select Date"
                      />
                      {/* {simpleValidator.current.message(
                        "eventDate",
                        eventDate,
                        "required"
                      )} */}
                    </Col>
                    <Col lg="6" md="6" sm="12" xs="12" className="mt-3">
                      <Label className="event-label">Crew Assembly Time</Label>
                      <Input
                        type="time"
                        name="crewAssemblyTime"
                        value={crewAssemblyTime}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter Crew Assembly Time"
                      />
                    </Col>
                    <Col lg="6" md="6" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="event-label">
                          Start Time
                          {/* <span className="event-required">*</span> */}
                        </Label>
                        <div className="event-given-checkbox">
                          <Input
                            type="checkbox"
                            className="mt-1 event-given-input"
                          />
                          <label className="event-given-input-text">
                            Not Given
                          </label>
                        </div>
                      </div>
                      <Input
                        type="time"
                        name="startTime"
                        value={startTime}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter Start Time"
                      />
                      {/* {simpleValidator.current.message(
                        "startTime",
                        startTime,
                        "required"
                      )} */}
                    </Col>
                    <Col lg="6" md="6" sm="12" xs="12" className="mt-3">
                      <Label className="event-label">
                        End Time
                        {/* <span className="event-required">*</span> */}
                      </Label>
                      <Input
                        type="time"
                        name="endTime"
                        value={endTime}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter Start Time"
                      />
                      {/* {simpleValidator.current.message(
                        "EndTime",
                        endTime,
                        "required"
                      )} */}
                    </Col>
                    <Col lg="6" md="6" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        {venueLocationAdd ? (
                          <Label className="event-label">
                            New Venue Location
                          </Label>
                        ) : (
                          <Label className="event-label">
                            Venue Location
                            {/* <span className="event-required">*</span> */}
                          </Label>
                        )}
                        <div
                          className="event-given-checkbox"
                          onClick={() => {
                            handleVenueTab()
                            setNewVenueLocation("")
                          }}
                        >
                          <Input
                            name="premium"
                            type="checkbox"
                            className="mt-1 event-given-input"
                            checked={venueLocationAdd ? true : false}
                            onClick={() => setNewVenueLocation("")}
                          />
                          <label className="event-given-input-text">
                            Add New
                          </label>
                        </div>
                      </div>
                      {venueLocationAdd ? (
                        <Input
                          name="newVenueLocation"
                          value={newVenueLocation}
                          onChange={(e) => setNewVenueLocation(e.target.value)}
                          placeholder="Enter Venue Location"
                        />
                      ) : (
                        <Select
                          name="venueLocation"
                          value={venueLocations}
                          options={venueLocationOptions}
                          isSearchable
                          placeholder="Select Venue Locations"
                          onChange={(e) => handleVenueLocations(e)}
                        />
                      )}
                      {venueLocationAdd ? (
                        <div
                          className="add-venue"
                          onClick={() => {
                            addVenueLocationDetails()
                            setVenueLocationAdded(true)
                          }}
                        >
                          <span>Add</span>
                          {/* Add */}
                        </div>
                      ) : addedVenueLocation ? (
                        <div style={{ color: "green" }}>
                          <i className="fa fa-check add-new-venue">Added</i>
                        </div>
                      ) : (
                        ""
                      )}
                      {/* {simpleValidator.current.message(
                        "venueLocation",
                        venueLocations,
                        "required"
                      )} */}
                    </Col>
                    <Col lg="6" md="6" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        {venueAdd ? (
                          <Label className="event-label">New Venue Name</Label>
                        ) : (
                          <Label className="event-label">
                            Venue Name
                            {/* <span className="event-required">*</span> */}
                          </Label>
                        )}
                        <div
                          className="event-given-checkbox"
                          onClick={() => {
                            handleVenueNameTab()
                            setNewVenue("")
                          }}
                        >
                          <Input
                            name="premium"
                            type="checkbox"
                            className="mt-1 event-given-input"
                            checked={venueAdd ? true : false}
                          />
                          <label className="event-given-input-text">
                            Add New
                          </label>
                        </div>
                      </div>
                      {venueAdd ? (
                        <Input
                          name="newVenue"
                          value={newVenue}
                          onChange={(e) => setNewVenue(e.target.value)}
                          placeholder="Enter Venue Name"
                        />
                      ) : (
                        <Select
                          type="text"
                          name="cityVenueName"
                          value={cityVenueName}
                          // noOptionsMessage={() => null}
                          showIcon={false}
                          isSearchable
                          autoComplete
                          options={cityVenueOptions}
                          onChange={(e) => setCityVenueName(e)}
                          placeholder="Enter Venue Name"
                        />
                      )}

                      <div className="d-flex flex-row">
                        {cityVenueName.isPremium === false ? (
                          ""
                        ) : (
                          <div>
                            <Input
                              type="checkbox"
                              // value={venue.premium}
                              name="premium"
                              value={premium}
                              checked={
                                cityVenueName.isPremium === true
                                  ? true
                                  : premium 
                                  ? true
                                  : false
                              }
                              className="event-premium-checkbox add-venue-name"
                              onChange={() => setPremium(!premium)}
                            />
                            <Label className="event-label mx-2 mt-1">
                              Premium
                            </Label>
                          </div>
                        )}

                        {venueAdd ? (
                          <div
                            className="add-venue"
                            onClick={() => {
                              addVenueDetails()
                              setVenueNameAdded(true)
                            }}
                          >
                            <span>Add</span>
                            {/* Add */}
                          </div>
                        ) : addedVenue ? (
                          <div style={{ color: "green" }}>
                            <i className="fa fa-check add-new-venue">Added</i>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>

                      {/* {simpleValidator.current.message(
                        "cityVenueName",
                        cityVenueName,
                        "required"
                      )} */}
                    </Col>
                    <Col
                      lg="6"
                      md="6"
                      sm="12"
                      xs="12"
                      className="event-crowd mt-1"
                    >
                      <Label className="event-label">Crowd Strength</Label>
                      <Input
                        type="text"
                        name="crowdStrength"
                        value={crowdStrength}
                        maxLength={6}
                        onChange={(e) => {
                          const re = /^[0-9\b/+]+$/
                          if (
                            e.target.value === "" ||
                            re.test(e.target.value)
                          ) {
                            handleChange(e)
                          }
                        }}
                        placeholder="Enter Crowd Strength"
                        className="client-number-field"
                      />
                    </Col>
                    {/* <Col
                      xl="6"
                      lg="6"
                      md="6"
                      sm="12"
                      xs="12"
                      className="d-flex event-form-premium"
                    >
                      <Input
                        type="checkbox"
                        className="event-premium-checkbox"
                        name="premium_check"
                      />
                      <Label className="event-label mx-2 mt-1">Premium</Label>
                    </Col> */}
                    <Col
                      xl="12"
                      lg="12"
                      md="12"
                      sm="12"
                      xs="12"
                      className="d-flex flex-column mt-3"
                    >
                      <Label className="event-label">Notes</Label>
                      <textarea
                        type="text"
                        name="notes"
                        value={notes}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter Notes"
                        className="event-crowd-textarea"
                      />
                    </Col>
                    <Col
                      xl="6"
                      lg="6"
                      md="6"
                      sm="12"
                      xs="12"
                      className="d-flex mt-3"
                    >
                      <Input
                        type="checkbox"
                        className="event-premium-checkbox"
                        name="branch_check"
                        onClick={() => setBranchShow(true)}
                        checked={branchShow ? true : false}
                      />
                      <Label className="event-label mx-2 mt-1">
                        Link to Branch
                      </Label>
                    </Col>

                    {eventLoading ? (
                      <Modal
                        show={eventLoading}
                        style={{ width: "10%", margin: "20% 50%" }}
                      >
                        <Modal.Body>
                          <Spinner
                            as="span"
                            animation="grow"
                            size="lg"
                            role="status"
                            aria-hidden="true"
                            variant="success"
                            className="mx-2"
                          />
                          <span>Loading...</span>
                        </Modal.Body>
                      </Modal>
                    ) : (
                      ""
                    )}
                    {branchShow && (
                      <Col
                        xl="6"
                        lg="6"
                        md="6"
                        sm="12"
                        xs="12"
                        className="mt-3 mb-3"
                      >
                        <Label className="event-label">Branch</Label>
                        <Select
                          name="cityName"
                          value={city}
                          options={
                            // recordsMetaData ? recordsMetaData.branchOptions : []
                            eventBranch
                          }
                          onChange={(e) => setCity(e)}
                          placeholder="Select Branch"
                        />
                      </Col>
                    )}

                    <Col
                      md="12"
                      xl="12"
                      lg="12"
                      className="event-details-submit"
                    >
                      {isEdit ? (
                        <>
                          <button
                            onClick={() => {
                              // setOpenModal(!openModal)
                              setEventModal(false)
                            }}
                            type="button"
                            className="btn btn-danger btn-label form-cancel-btn"
                          >
                            <i className="bx bx-block label-icon "></i>
                            Cancel
                          </button>
                          <button
                            type="submit"
                            onClick={(e) => {
                              setEventModal(!eventModal)
                              handleUpdate(e)
                            }}
                            className="btn btn-success btn-label form-submit-btn"
                          >
                            <i className="bx bx-check-double label-icon"></i>
                            Update
                          </button>
                        </>
                      ) : (
                        <>
                          {" "}
                          <button
                            onClick={() => {
                              setEventModal(false)
                            }}
                            type="button"
                            className="btn btn-danger btn-label form-cancel-btn"
                          >
                            <i className="bx bx-block label-icon "></i>
                            Cancel
                          </button>
                          <button
                            type="submit"
                            onClick={(e) => {
                              setEventModal(!eventModal)
                              handleSubmit(e)
                            }}
                            className="btn btn-success btn-label form-submit-btn"
                          >
                            <i className="bx bx-check-double label-icon"></i>
                            Submit
                          </button>
                        </>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </form>
          )}
        </Col>
        {/* Event details End */}
      </Row>
    </React.Fragment>
  )
}

EcEventDetails.propTypes = {
  dispatch: PropTypes.func,
  record_event_details: PropTypes.array,
  record_client_profile: PropTypes.array,
  clientProfile: PropTypes.array,
  event_date: PropTypes.array,
  offer_list: PropTypes.array,
  recordsMetaData: PropTypes.object,
  records: PropTypes.array,
  error: PropTypes.any,
  access: PropTypes.array,
  metaData: PropTypes.object,
  multiArrayLeadId: PropTypes.any,
  ecLoading: PropTypes.any,
  loading: PropTypes.any,
  location: PropTypes.array,
  onChange: PropTypes.func,
  success: PropTypes.any,
  fuseOptions: PropTypes.any,
}
const mapStateToProps = (state) => ({
  eventProps: state.Event.record_event_details,
  eventDate: state.Event.event_date,
})

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
    // loadRecordClientDetails,
    // createRecord,
    // deleteRecord,
    // updateRecord,
  )(EcEventDetails)
)
